import OrganizationPostsSummary from "./OrganizationPostsSummary";
export default OrganizationPostsSummary;
